var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container o-html-block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.hTML)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }